import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'
import {
  maxMobileScreenWidth,
  minDesktopScreenWidth
} from 'src/utils/breakpoints'

type hoverProps = {
  readonly hasHover: boolean
}

export const LinkC = styled(LinkR)`
  display: flex;
  width: 100%;
  text-decoration: none;
`

export const Link = styled(LinkR)`
  display: flex;
  width: fit-content;
  padding-top: 16px;

  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #009fdf;

  cursor: pointer;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: transform 0.5s;

  &:hover {
    border-bottom: 1px solid #009fdf;
  }

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    font-size: 13px;
    padding-top: 8px;
  }
`

export const ReadMoreLabel = styled.p`
  display: flex;
  width: fit-content;
  padding-top: 16px;

  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #009fdf;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    font-size: 13px;
    padding-top: 8px;
  }
`

export const CardContainer = styled.div<hoverProps>`
  display: flex;
  background: #eef2f6;
  width: 100%;
  border: 1px solid transparent;

  ${({ hasHover: hoverActive }) =>
    hoverActive &&
    `
      &:hover {
        cursor: pointer;
        border: 1px solid #2E2972;
        transition: all 0.2s ease-in-out;
        filter: brightness(95%);
      }
  `}

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    flex-direction: column;
    padding: 16px 12px;
  }

  @media only screen and (min-width: ${minDesktopScreenWidth}px) {
    padding: 18px 8px 18px 24px;
    justify-content: space-between;
  }
`

export const TagsContainer = styled.div`
  display: flex;
  gap: 12px;
`

export const CardHeaderContainer = styled.div`
  display: flex;
  width: 100%;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  @media only screen and (min-width: ${minDesktopScreenWidth}px) {
    flex-direction: column;
  }
`

export const CardTitle = styled.p`
  display: flex;
  color: rgba(0, 0, 0, 0.87);
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;

  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    font-size: 14px;
    line-height: 16px;
  }

  @media only screen and (min-width: ${minDesktopScreenWidth}px) {
    padding: 8px 0;
  }
`

export const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 75%;
  @media only screen and (max-width: ${maxMobileScreenWidth}px) {
    width: 100%;
  }
`

export const RightCol = styled.div`
  width: 25%;
  display: flex;
  align-items: center;
`
